import { AfterViewInit, Component, inject, OnInit } from '@angular/core';
import { Accordion, AccordionContent, AccordionHeader, AccordionPanel } from 'primeng/accordion';
import { Card } from 'primeng/card';
import { SafeHtmlPipe } from '../../../core/pipes/safe-html.pipe';
import { I18nService } from '../../../core/services/i18n.service';
import { SpsSupportInfoComponent } from '../../../custom/components/sps-support-info/sps-support-info.component';
import { FaqList } from '../../interfaces/faq/faq-list';
import { FaqDataService } from '../../services/faq-data.service';
import { BaseComponent } from '../base/base.component';

@Component({
  selector: 'app-help-dummy',
  imports: [
    Card,
    SafeHtmlPipe,
    Accordion,
    AccordionPanel,
    AccordionHeader,
    AccordionContent,
    SpsSupportInfoComponent
  ],
  templateUrl: './help-faq.component.html'
})
export class HelpFaqComponent extends BaseComponent implements OnInit, AfterViewInit {

  public i18n = inject(I18nService);
  public faqService = inject(FaqDataService);
  public faqList: FaqList = null;

  constructor() {
    super();
  }

  ngOnInit() {
    this.loading = true;
    this.faqService.getFaqData(this.i18n.activeLanguageKey()).subscribe({
      next: data => {
        this.faqList = data;
        this.loading = false;
      },
      error: err => {}
    })

  }

  ngAfterViewInit(): void {
    /**
     * Some controls need refresh after language-changes
     */
    this.subscriptions.add(
      this.i18n.languageChanged.subscribe({
        next: value => {
          this.refreshControls = true;
          setTimeout(() => {
            this.refreshControls = false;
          }, 10);
        }
      })
    )
    /**
     * Initialize Breadcrumb-Items
     */
    setTimeout(() => {
      this.i18n.breadcrumbMenuItems.set([
        {
          icon: 'pi pi-home',
          i18nLabelKey: 'MENUDASHBOARD',
          label: this.i18n.i18nLng()['MENUDASHBOARD'],
          routerLink: ['/dashboard'],
          routerLinkActive: false,
        },
        {
          i18nLabelKey: 'MENUHELP',
          label: this.i18n.i18nLng()['MENUHELP'],
          routerLinkActive: false,
        },
        {
          i18nLabelKey: 'MENUFAQ',
          label: this.i18n.i18nLng()['MENUFAQ'],
          routerLinkActive: true,
        },
      ]);
    }, 50);
  }

}
